import React, { useEffect, useState } from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import EntityIndicatorDialog from '../EntityIndicatorDialog'
import { Divider, Grid2 } from '@mui/material'
import IndicatorHeaderDialog from '../IndicatorHeaderDialog'
import IndicatorTable from '../IndicatorTable'
import { shallowEqual, useSelector } from 'react-redux'
import { getYear } from 'utils/DateUtil'
import { CHECKBOX, P104_3, VP_020, VP_059, VP_060, VP_061, VP_063, VP_077, VP_201, VP_220, VP_221, VP_224, VP_225, VP_226, VP_227, VP_231, VP_232, VP_234, VP_235 } from 'rpqs/constants/RpqsConstant'
import { getIndicatorDialogRow, updateIndicatorEntity } from 'rpqs/utils/RPQSUtils'
import { round } from 'lodash'

const DialogP104_3 = ({
    open = false,
    setOpen = () => {},
    title = '',
}) => {
    const {
        managementEntity,
    } = useSelector(store => ({
        managementEntity: store.CollectivityReducer.managementEntity,
    }), shallowEqual)

    const [entityDialog, setEntityDialog] = useState(managementEntity)

    useEffect(() => {
        setEntityDialog(managementEntity)
    }, [managementEntity])

    const year = getYear(entityDialog?.dateEnd)
    const previousYear = year-1
    const currentEntity = entityDialog?.[year]

    const formatedIndicators = [
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_077.code,
            indicatorName: i18n[VP_077.i18n],
            unit: 'km',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_077.code,
                { ...currentEntity?.[VP_077.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_059.code,
            indicatorName: i18n[VP_059.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_059.code,
                { ...currentEntity?.[VP_059.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_060.code,
            indicatorName: i18n[VP_060.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_060.code,
                { ...currentEntity?.[VP_060.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_061.code,
            indicatorName: i18n[VP_061.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_061.code,
                { ...currentEntity?.[VP_061.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_063.code,
            indicatorName: i18n[VP_063.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_063.code,
                { ...currentEntity?.[VP_063.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_201.code,
            indicatorName: i18n[VP_201.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_201.code,
                { ...currentEntity?.[VP_201.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_220.code,
            indicatorName: i18n[VP_220.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_220.code,
                { ...currentEntity?.[VP_220.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_221.code,
            indicatorName: i18n[VP_221.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_221.code,
                { ...currentEntity?.[VP_221.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_224.code,
            indicatorName: i18n[VP_224.i18n],
            unit: i18n.m3KmD,
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_224.code,
                { ...currentEntity?.[VP_224.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_225.code,
            indicatorName: i18n[VP_225.i18n],
            unit: '%',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_225.code,
                { ...currentEntity?.[VP_225.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_226.code,
            indicatorName: i18n[VP_226.i18n],
            unit: '%',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_226.code,
                { ...currentEntity?.[VP_226.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_227.code,
            indicatorName: i18n[VP_227.i18n],
            unit: '%',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_227.code,
                { ...currentEntity?.[VP_227.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_231.code,
            indicatorName: i18n[VP_231.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_231.code,
                { ...currentEntity?.[VP_231.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_234.code,
            indicatorName: i18n[VP_234.i18n],
            unit: 'm3',
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_234.code,
                { ...currentEntity?.[VP_234.code], value: parseInt(v) || 0 },
            ))),
        }),
        getIndicatorDialogRow({
            entityDialog,
            codeIndicator: VP_235.code,
            indicatorName: i18n[VP_235.i18n],
            inputType: CHECKBOX,
            onChange: v => setEntityDialog(prev => (updateIndicatorEntity(prev, year, VP_235.code,
                { ...currentEntity?.[VP_235.code], value: v },
            ))),
        }),
    ]

    const onStatusChange = (status) => {
        setEntityDialog(updateIndicatorEntity(entityDialog, year, P104_3.code, { ...currentEntity?.[P104_3.code], status }))
    }

    const getIndicatorValue = (indicator) => (currentEntity?.[indicator?.code]?.value || 0)

    const calculation = () => {
        const calculatedValue = getIndicatorValue(VP_059) + getIndicatorValue(VP_060) !== 0 ? round((getIndicatorValue(VP_232) + getIndicatorValue(VP_231) + getIndicatorValue(VP_020) + getIndicatorValue(VP_061)) / (getIndicatorValue(VP_059) + getIndicatorValue(VP_060)) * 100, 2) : getIndicatorValue(P104_3)

        return updateIndicatorEntity(entityDialog, year, P104_3.code, { ...currentEntity?.[P104_3.code], value: calculatedValue })
    }

    return (
        <EntityIndicatorDialog
            open={open}
            setOpen={setOpen}
            title={title}
            hasNote
            entityDialog={entityDialog}
            setEntityDialog={setEntityDialog}
            codeIndicator={P104_3.code}
            calculationOnRegister={calculation}
        >
            <Grid2 container direction={'column'} gap={2}>
                <IndicatorHeaderDialog
                    current={{
                        year,
                        value: managementEntity?.[year]?.[P104_3.code]?.value,
                    }}
                    previous={{
                        year: previousYear,
                        value: managementEntity?.[previousYear]?.[P104_3.code]?.value,
                    }}
                    status={entityDialog?.[year]?.[P104_3.code]?.status}
                    onStatusChange={onStatusChange}
                    unit={i18n.m3KmD}
                />
                <Divider/>
                <IndicatorTable
                    year={year?.toString()}
                    indicators={formatedIndicators}
                />

            </Grid2>
        </EntityIndicatorDialog>
    )
}

DialogP104_3.propTypes = {
    setOpen: PropTypes.func,
    open: PropTypes.bool,
    title: PropTypes.string,
}

export default DialogP104_3
